import $ from 'jquery';
import select2 from 'select2/dist/js/select2'

export const init = () => {
  select2();

  if ($('.suggest').length) {
    $('.suggest').select2({
      placeholder: '選択してください'
    });
  }
}
